import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {Icon} from '@components/common/base/icon'
import {cn} from '@containers/html-utils'
import {useCompanyInvitePopupStore} from './company-invite-popup-store'
import {EmailsInput, Props} from './emails-input'

const TwErrorContainer = tw.div`
  flex
  items-center
  cursor-default
`

const TwErrorText = tw.div`
  text-xs-regular
  text-status-error
`
const TwWaringText = tw.div`
  text-xs-regular
  text-status-warning
`

export const EmailsInputWithErrors = observer((props: Props) => {
  const [, store] = useCompanyInvitePopupStore()

  const lang = Lang.msg.invitePopup

  const hasLicenseLimit = store.hasLicenseLimit()

  return (
    <div className={cn('flex flex-col gap-8', props.className)}>
      <EmailsInput
        {...props}
        onChange={store.setEmails}
        validate={store.validateEmail}
      />

      {store.hasErrors && (
        <TwErrorContainer>
          <Icon icon={'IconCustomUsersAdd'} color={'status-error'} />
          <TwErrorText> {lang.error1}</TwErrorText>
        </TwErrorContainer>
      )}

      {hasLicenseLimit && (
        <TwErrorContainer>
          <Icon icon={'IconCustomUsersAdd'} color={'status-error'} />
          <TwErrorText>
            {lang.error2(store.licenseCount, store.needLicenseCount())}
          </TwErrorText>
        </TwErrorContainer>
      )}

      {store.hasWarnings && (
        <TwErrorContainer>
          <Icon icon={'IconCustomUsersAdd'} color={'status-warning'} />
          <TwWaringText> {lang.error3}</TwWaringText>
        </TwErrorContainer>
      )}
    </div>
  )
})
